import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data/data.service';
import { DailyReport } from 'src/app/services/types/daily-report.model';
import { FileMeta } from 'src/app/services/types/file-meta.model';
import { ModalUploaderComponent } from '../model-uploader/modal-uploader.component';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-modal-daily-report',
  templateUrl: 'modal-daily-report.component.html',
  styleUrls: ['../../pages/daily-importer-v3/daily-importer-v3.page.scss', './modal-daily-report.component.scss'],
  providers: [DataService, DatePipe],
})
export class ModalDailyReportComponent implements OnInit {
  dr?: DailyReport
  jobName?: string;
  guid?: string;
  selectedOspId?: string;
  CPID?: string;

  constructor(
    
    private modalCtrl: ModalController,
    private toastService: ToastService,
    private dataService: DataService,
    private datePipe: DatePipe,
  ) {}
  ngOnInit(): void {
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async confirm() {
    return this.modalCtrl.dismiss('confirm', 'confirm');
  }

  transformDate(date: string) {
    const dateString = this.datePipe.transform(date, 'MM-dd-yyyy');
    return dateString;
  }

  presentModal(dr?: DailyReport) {
      let title = this.jobName;
      
        title = `${title}>${this.transformDate(dr.workDate)} ${dr.qty} ${
          dr.code
        }`;
  
        if (dr.withAttachments) {
          this.dataService.getDRFiles(this.guid, dr.recordId).subscribe(
            (data) => {
              let files: FileMeta[] = [];
              (data as []).forEach((item) => {
                files.push(new FileMeta(item));
              });
  
              this.showPopup(title, files, dr.recordId);
            },
            (error) => {
              console.log(error);
  
              this.toastService.presentToast(
                'Error',
                'Error while getting files',
                'top',
                'danger',
                4000
              );
            }
          );
        } else {
          this.showPopup(title, [], dr.recordId);
        }
    }

    async showPopup(title?: string, files?: any, drId?: number) {
        const modal = await this.modalCtrl.create({
          component: ModalUploaderComponent,
          componentProps: {
            uploadedFiles: files.filter((f) => f.category != 'Client SOW'),
            drId: drId,
            ospId: this.selectedOspId,
            cpId: this.CPID,
            title: title,
          },
        });
        modal.present();
        const { data, role } = await modal.onWillDismiss();
    
        if (role === 'confirm') {
          this.toastService.presentToast(
            'Success',
            `Uploaded`,
            'top',
            'success',
            4000
          );
        }
        if (role === 'cancel' && data == 'error') {
          this.toastService.presentToast(
            'Error',
            'Error while saving',
            'top',
            'danger',
            4000
          );
        }
      }
      
      getDRAttachmentColor(dr: DailyReport) {
        if (dr?.withAttachments) return 'darkblue';
    
        return '';
      }
}
